// @flow

import React from "react";
import { Row, Col } from "@components";
import { SingleQuestionAnswerWithConsent } from "../single-question-answer-with-consent";
import type { Question } from "../single-question-answer-with-consent";

export type AnswersWithConsent = {
  [key: string]: $Exact<{
    answer: any,
    consentToShare?: boolean,
  }>,
};

export type Props = $Exact<{
  questions: Array<Question>,
  answers: AnswersWithConsent,
  columnsPerRow: number,
  onChange: Object => void,
}>;

export class QuestionAnswerContainer extends React.Component<Props> {
  static defaultProps = {
    columnsPerRow: 2,
  };

  handleChange = (value: Object) => {
    const state = { ...this.state };
    const dynamicKey = Object.keys(value)[0];

    if (state && state[dynamicKey]) {
      this.setState({
        [dynamicKey]: {
          ...state[dynamicKey],
          ...value[dynamicKey],
        },
      });

      this.props.onChange({
        answers: {
          ...state,
          [dynamicKey]: {
            ...state[dynamicKey],
            ...value[dynamicKey],
          },
        },
        isValid:
          "consentToShare" in value[dynamicKey]
            ? typeof state[dynamicKey].answer === "boolean" || state[dynamicKey].answer?.length
            : typeof value[dynamicKey].answer === "boolean" || value[dynamicKey].answer?.length,
      });
    } else {
      const answers = {
        ...this.props.answers,
        ...state,
        ...value,
      };
      const currentAnswerKey = Object.keys(value)[0];

      this.setState(answers);
      this.props.onChange({
        answers,
        isValid:
          typeof value[currentAnswerKey].answer === "boolean" ||
          value[currentAnswerKey].answer?.length,
      });
    }
  };

  idName = (question: Question) => {
    return question.questionLabel ? `${question.questionLabel}-${question.id}` : `${question.id}`;
  };

  answer = (idName: string) => {
    let answer =
      this.props.answers[idName] !== undefined ? this.props.answers[idName].answer : null;
    if (this.state && this.state[idName]) {
      return this.state[idName].answer !== undefined ? this.state[idName].answer : answer;
    }
    return answer;
  };

  consentToShare = (idName: string) => {
    let consentToShare =
      this.props.answers[idName] !== undefined ? this.props.answers[idName].consentToShare : null;
    if (this.state && this.state[idName]) {
      return this.state[idName].consentToShare !== undefined
        ? this.state[idName].consentToShare
        : consentToShare;
    }
    return consentToShare;
  };

  render() {
    const { questions, columnsPerRow } = this.props;
    return (
      <div className="question-answer-container">
        <Row>
          {questions.map((question, index) => {
            const idName = this.idName(question);

            return (
              <Col xs={12 / columnsPerRow} key={question.id} className="pb-4">
                <SingleQuestionAnswerWithConsent
                  onChange={this.handleChange}
                  question={question}
                  consentToShare={this.consentToShare(idName)}
                  value={this.answer(idName)}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
}

export default QuestionAnswerContainer;
